import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";

export const Pricing = () => {
  const { t } = useI18n();
  const tiers = [
    {
      name: t("pricing.t1_t"),
      price: `${t("pricing.from")} 390€`,
      desc: t("pricing.t1_d"),
      features: [t("pricing.t1_f1"), t("pricing.t1_f2"), t("pricing.t1_f3"), t("pricing.t1_f4"), t("pricing.t1_f5")],
      highlighted: false,
    },
    {
      name: t("pricing.t2_t"),
      price: `${t("pricing.from")} 1 290€`,
      desc: t("pricing.t2_d"),
      features: [t("pricing.t2_f1"), t("pricing.t2_f2"), t("pricing.t2_f3"), t("pricing.t2_f4"), t("pricing.t2_f5")],
      highlighted: true,
    },
    {
      name: t("pricing.t3_t"),
      price: `${t("pricing.from")} 2 490€`,
      desc: t("pricing.t3_d"),
      features: [t("pricing.t3_f1"), t("pricing.t3_f2"), t("pricing.t3_f3"), t("pricing.t3_f4"), t("pricing.t3_f5")],
      highlighted: false,
    },
  ];
  return (
    <section id="pricing" data-testid="pricing-section" className="py-24 sm:py-32 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] uppercase text-zinc-500 mb-4">
              {t("pricing.label")}
            </p>
            <h2 className="font-display text-3xl sm:text-5xl tracking-tighter max-w-2xl">
              {t("pricing.title_a")}
              <em className="italic text-zinc-400">{t("pricing.title_em")}</em>
              {t("pricing.title_b")}
            </h2>
          </div>
          <p className="text-sm text-zinc-400 max-w-md">{t("pricing.intro")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {tiers.map((tier, idx) => (
            <article
              key={idx}
              data-testid={`pricing-tier-${idx}`}
              className={`p-8 sm:p-10 flex flex-col ${
                tier.highlighted ? "bg-white text-zinc-950" : "bg-zinc-950 text-zinc-100"
              }`}
            >
              <div className="flex items-center justify-between mb-8">
                <h3 className="font-display text-2xl tracking-tight">{tier.name}</h3>
                <span className={`font-mono text-xs ${tier.highlighted ? "text-zinc-700" : "text-zinc-500"}`}>
                  0{idx + 1}
                </span>
              </div>
              <p className="font-display text-3xl tracking-tighter mb-2">{tier.price}</p>
              <p className={`text-sm mb-8 ${tier.highlighted ? "text-zinc-700" : "text-zinc-400"}`}>{tier.desc}</p>
              <ul className="space-y-3 mb-10 flex-1">
                {tier.features.map((f, fi) => (
                  <li
                    key={fi}
                    className={`flex items-start gap-3 text-sm ${tier.highlighted ? "text-zinc-800" : "text-zinc-300"}`}
                  >
                    <Check
                      size={16}
                      strokeWidth={1.5}
                      className={`mt-0.5 ${tier.highlighted ? "text-zinc-950" : "text-zinc-100"}`}
                    />
                    {f}
                  </li>
                ))}
              </ul>
              <Link
                to="/simulateur"
                data-testid={`pricing-cta-${idx}`}
                className={`inline-flex items-center justify-center px-6 py-3 text-sm font-medium tracking-wide transition-colors ${
                  tier.highlighted
                    ? "bg-zinc-950 text-white hover:bg-zinc-800"
                    : "border border-white/30 hover:bg-white hover:text-zinc-950"
                }`}
              >
                {t("pricing.cta")}
              </Link>
            </article>
          ))}
        </div>

        <p className="mt-8 text-xs text-zinc-500 text-center">{t("pricing.foot")}</p>
      </div>
    </section>
  );
};
